const firebaseConfig = {
  apiKey: "AIzaSyBnNRx3b-zH1xvIp2RmLQzUtPsqvI_VEIM",
  authDomain: "travelogue-e7025.firebaseapp.com",
  projectId: "travelogue-e7025",
  storageBucket: "travelogue-e7025.appspot.com",
  messagingSenderId: "382455737711",
  appId: "1:382455737711:web:f577ed48eafb2d1aa74c9a"
};
  export default firebaseConfig;